export function getUniqueSymbols(rows) {
    if (rows) {
        const tse_url_array = {}
        rows.map(item => (
                tse_url_array[item.tse_url] = item.l18
            )
        )
        return tse_url_array
    }
    return []
}


export function rotateRowsDate() {
    const rowsDateKeyName = 'rowsDate'
    // Check if the date exists in localStorage
    let rowsDate = localStorage.getItem(rowsDateKeyName);
    const today = new Date();
    const todayString = today.toISOString().slice(0, 10); // Format as YYYY-MM-DD

    if (!rowsDate) {
        // If it doesn't exist, create a new date string and store it
        localStorage.setItem(rowsDateKeyName, todayString);
    }
    rowsDate = localStorage.getItem(rowsDateKeyName);

    // Retrieve the date from localStorage
    // if (rowsDate !== todayString) {
    // clearIndexDBStore('rows', 'rowsStore')
    // }
}


export function setToLocalStorage(key, value, zip = false, concat = false) {
    localStorage.setItem(key, JSON.stringify(value))
}

export function loadFromLocalStorage(key, zip = false) {
    return JSON.parse(localStorage.getItem(key))
}